import * as React from 'react'

import { Box, Colors, Table, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import StatusTag from 'modules/complaints/components/StatusTag'
import type Complaint from 'modules/complaints/store/models/Complaint'

interface RowColors {
  background: Colors
  text: {
    name: Colors
    message: Colors
  }
}

const COLORS: { selected: RowColors; unselected: RowColors } = {
  selected: {
    background: 'grey800',
    text: {
      name: 'grey000White',
      message: 'grey000White',
    },
  },
  unselected: {
    background: 'grey000White',
    text: {
      name: 'grey800',
      message: 'grey1000',
    },
  },
}
interface Props {
  complaints: Complaint[]
  onComplaintSelect: (id: number | null) => void
  selectedComplaint: number | null
}

export default function TableBody({ complaints, onComplaintSelect, selectedComplaint }: Props) {
  const onRowClick = (complaint: Complaint) => {
    onComplaintSelect(complaint.id)
  }

  const hasComplaints = !!complaints.length

  return (
    <Table.Body>
      {!hasComplaints && (
        <Table.Row>
          <Table.Cell colSpan={12}>
            <Box alignItems="center" justifyContent="center" padding="s24">
              <Text.Normal>{i18n.t('complaints.table.empty')}</Text.Normal>
            </Box>
          </Table.Cell>
        </Table.Row>
      )}
      {hasComplaints &&
        complaints.map((complaint) => {
          const colors: RowColors =
            selectedComplaint === complaint.id ? COLORS.selected : COLORS.unselected

          return (
            <Table.Row
              background={colors.background}
              key={complaint.id}
              onClick={() => onRowClick(complaint)}
            >
              <Table.Cell colSpan={3}>
                <Box flexDirection="row" justifyContent="spaceBetween" paddingBottom="s8">
                  <Text.Normal size="200" color={colors.text.name} ellipsis>
                    {complaint.complainerName || i18n.t('complaints.complaint.anonymous')}
                  </Text.Normal>
                  <StatusTag complaint={complaint} />
                </Box>
                <Box gap="s8">
                  <Text.Normal size="300" color={colors.text.message} weight="medium" ellipsis>
                    {complaint.description}
                  </Text.Normal>
                  {complaint.isDueSoon && (
                    <Text.Normal size="200" color="radicalRed1000" weight="medium">
                      {i18n.t('complaints.complaint.due_soon')}
                    </Text.Normal>
                  )}
                </Box>
              </Table.Cell>
            </Table.Row>
          )
        })}
    </Table.Body>
  )
}
